import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Blog Categories'
export const group = 'Dynamic Post Template'
export const beta = false
import { defaultOptions } from './ElCategories'

export const icon = ''

export default class ElPostCategories extends SectionProvider {
  constructor (options = {}) {
    super('ElBlogCategories', options)

    this.name = name
    this.group = group
    this.defaultOptions = defaultOptions
  }
}
